import { UnitStatusKey } from '~/providers/types/unit';

export type MaintenanceViewBy = 'machines' | 'capacity';

export type MaintenanceFilters = {
  clients: number[];
  unitStatuses: UnitStatusKey[];
  states: string[];
  cities: string[];
  units: number[];
  brands: string[];
  machineTypes: string[];
  fluids: string[];
};

export const emptyMaintenanceFilters: MaintenanceFilters = {
  clients: [],
  unitStatuses: [],
  states: [],
  cities: [],
  units: [],
  brands: [],
  machineTypes: [],
  fluids: [],
};
